import {sendGTMEvent} from '@next/third-parties/google';

export function trackEvent(name: string, data?: Record<string, any>) {
  sendGTMEvent({event: name, ...data});
}
